<style scoped>
.form-error {
  color: red;
  margin-left: 0;
  margin-top: -14px;
}
</style>
<template>
  <form style="width:100%">
    <div style="width:100%;">
      <img
        style="width:8rem;display: block;margin-left: auto;margin-right: auto;margin-bottom:2rem"
        :src="'/assets/technology/awsiotcore.jpg'"
      />
    </div>
    <v-layout row wrap align-center>
      <v-flex xs12 style="margin-bottom:2rem">
        <div>
          <p style="margin-bottom:0" class="body-2">
            <v-icon small>memory</v-icon> Device credentials
          </p>
          <p style="margin-bottom:0" class="caption">
            Select how device credentials have to provided to establish cloud
            connection
          </p>
        </div>
        <v-radio-group v-model="generated">
          <v-radio
            v-if="showHttps"
            color="#39a9dc"
            :label="`Connect via HTTPS`"
            :value="false"
          ></v-radio>
          <v-radio
            color="#39a9dc"
            :label="
              `Connect via MQTT: private key and device certificate generated on the cloud`
            "
            :value="true"
          ></v-radio>
          <v-radio
            v-if="showExistingCertificate"
            color="#39a9dc"
            :label="`Use existing certificate`"
            :value="false"
          ></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex
        xs12
        style="margin-bottom:2rem"
        v-if="!generated && showExistingCertificate"
      >
        <div>
          <p style="margin-bottom:0" class="body-2">X509 device certificate</p>
          <p style="margin-bottom:0" class="caption">
            Put here PEM string of existing device certificate
          </p>
        </div>
        <v-textarea v-model="model.certificate"></v-textarea>
      </v-flex>
    </v-layout>

    <v-btn block dark v-on:click="submit()" color="#39a9dc"> Submit </v-btn>
  </form>
</template>
<script>
export default {
  props: {
    model: Object,
    showHttps: Boolean,
    showExistingCertificate: Boolean,
  },

  data() {
    return {
      generated: true,
    };
  },

  watch: {
    generated() {
      this.model.certificate = this.generated
        ? undefined
        : this.model.certificate;
      this.model.hide_credentials = this.showHttps && !this.generated;
    },
  },

  created() {
    this.model.certificate = undefined;
    this.model.hide_credentials = false;
  },

  methods: {
    async submit() {
      return new Promise(
        async (resolve, reject) =>
          await this.$validator.validate().then((valid) => {
            if (valid) {
              this.model.hide_credentials = this.showHttps && !this.generated;
              this.$emit("submit");
              resolve();
            } else {
              reject();
            }
          }),
      );
    },
  },
};
</script>
